Postlogin = (function (postlogin) {
    postlogin.MyProfile = {};
    const self = postlogin.MyProfile;

    self.init = function () {
        // Ported from bootstrap-select to Tom Select 2026-05-11 as
        // prep for the Bootstrap 5 upgrade. This picker is read-only
        // (the user can see their licenses here but edits happen
        // elsewhere), so the config is minimal; remove_button gives
        // Tom Select its own chip styling, not edit affordance.
        const licenseDisplay = document.getElementById('license-display');
        if (licenseDisplay) {
            // eslint-disable-next-line no-new
            new TomSelect(licenseDisplay, {
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }

        if (Jr.getLicenseSetting('profile_allow_name_change')) {
            $('#edit-personal-info').show();
        }
        if (Jr.getLicenseSetting('profile_allow_password_change')) {
            $('#edit-password').show();
        }

        // eslint-disable-next-line no-new
        new self.Edit();
    };

    self.Edit = VjsUtility.Controller.extend({
        currentUserData: {},
        events: {
            'click .edit-section-btn': 'unlockSectionForEdit',
            'click .save-field-btn': 'saveFieldEdit',
            'click .edit-field-btn': 'unlockFieldForEdit',
            'click .save-section-btn': 'saveEdit',
            'click .cancel-edit-btn': 'cancelEdit',
            'click button#validate-email-btn': 'clickSendValidationEmail',
            'click button#delete-email-btn': 'deleteEmail',
            'click button#add-email-btn': 'enableEmailEdit',
            'click button#edit-email-btn': 'enableEmailEdit',
            'click button#cancel-email-edit-btn': 'cancelEmailEdit',
            'click button#save-email-btn': 'clickSaveEmail',
            'keypress #password': 'keypressPassword',
            'keypress #confirm-password': 'keypressPassword',
        },

        keypressPassword(e) {
            if (+e.which === 13) {
                e.preventDefault();

                $('#password').siblings('.save-field-btn')[0].click();
            }
        },

        unlockSectionForEdit(e) {
            e.preventDefault();

            this.toggleEditButtons(e);
            this.toggleEditSection(e);
            this.getCurrentUserData(e);
        },

        unlockFieldForEdit(e) {
            e.preventDefault();

            this.toggleEditButtons(e);
            this.toggleEditField(e);
            this.getCurrentUserData(e);
        },

        unlockEmailEdit(e) {
            e.preventDefault();

            this.getCurrentUserData(e);
            this.toggleEmailButtons(e);
        },

        saveFieldEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.saveCurrentUserData(e);
        },

        saveEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.saveCurrentUserData(e);
        },

        cancelEdit(e) {
            e.preventDefault();

            this.clearErrorFields();
            this.toggleEditButtons(e);

            const editType = $(e.currentTarget).data('type');

            if (editType === 'section') {
                this.toggleEditSection(e);
                this.resetSectionEdits(e);
            }

            if (editType === 'field') {
                this.toggleEditField(e);
                this.resetFieldEdits(e);
            }
        },

        clearErrorFields() {
            $('.field-error').remove();
        },

        enableEmailEdit(e) {
            e.preventDefault();
            this.getCurrentUserData(e);

            const emailField = $('#email');
            const emailPlaceholder = $('.email-field .profile-field');
            const validateEmailBtn = $('#validate-email-btn');
            const validatedBtn = $('#validated-btn');
            const deleteBtn = $('#delete-email-btn');
            const addEmailBtn = $('#add-email-btn');
            const editEmailBtn = $('#edit-email-btn');
            const saveBtn = $('#save-email-btn');
            const cancelBtn = $('#cancel-email-edit-btn');

            emailPlaceholder.addClass('hidden');
            emailField.removeClass('hidden');
            validateEmailBtn.addClass('hidden');
            validatedBtn.addClass('hidden');
            deleteBtn.addClass('hidden');
            addEmailBtn.addClass('hidden');
            editEmailBtn.addClass('hidden');

            saveBtn.removeClass('hidden');
            cancelBtn.removeClass('hidden');
        },

        cancelEmailEdit(e) {
            e.preventDefault();

            const emailField = $('#email');
            const emailPlaceholder = $('.email-field .profile-field');
            const validateEmailBtn = $('#validate-email-btn');
            const validatedBtn = $('#validated-btn');
            const deleteBtn = $('#delete-email-btn');
            const addEmailBtn = $('#add-email-btn');
            const editEmailBtn = $('#edit-email-btn');
            const saveBtn = $('#save-email-btn');
            const cancelBtn = $('#cancel-email-edit-btn');

            if (this.currentUserData.email !== '' && this.currentUserData.email) {
                emailPlaceholder.removeClass('hidden');
                editEmailBtn.removeClass('hidden');
                addEmailBtn.addClass('hidden');
                deleteBtn.removeClass('hidden');

                const validatedEmail = validateEmailBtn.data('validated-email');

                // if the validated email is the same as the saved email then show the validated button
                if (validatedEmail && validatedEmail === this.currentUserData.email) {
                    validatedBtn.removeClass('hidden');
                } else {
                    validatedBtn.addClass('hidden');
                }
                // if the validated email does not match the current email then show the validate me button
                if (validatedEmail && validatedEmail !== this.currentUserData.email) {
                    validateEmailBtn.removeClass('hidden');
                } else {
                    validateEmailBtn.addClass('hidden');
                }
                if (!validatedEmail && this.currentUserData.email) {
                    validateEmailBtn.removeClass('hidden');
                }
            } else {
                editEmailBtn.addClass('hidden');
                addEmailBtn.removeClass('hidden');
                deleteBtn.addClass('hidden');
                validateEmailBtn.addClass('hidden');
                validatedBtn.addClass('hidden');
            }

            emailField.addClass('hidden');
            saveBtn.addClass('hidden');
            cancelBtn.addClass('hidden');
        },

        toggleEditButtons(e) {
            const editButton = $(e.currentTarget);
            const saveCancelButtons = $(e.currentTarget).siblings(
                '.save-field-btn, .cancel-edit-btn, .edit-field-btn, .save-section-btn, .edit-section-btn',
            );

            editButton.toggleClass('hidden');
            saveCancelButtons.toggleClass('hidden');
        },

        toggleEditField(e) {
            const currentEdit = $(e.currentTarget);
            const inputField = currentEdit.siblings('.edit-field');
            const inputPlaceholder = currentEdit.siblings('.profile-field');

            inputPlaceholder.toggleClass('hidden');
            inputField.toggleClass('hidden');

            if (inputField.is('#password')) {
                // find the password confirm and toggle it.
                const confirmPasswordField = $('.password-confirm');
                confirmPasswordField.toggleClass('hidden');
            }
        },

        toggleEditSection(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFieldPlaceholders = section.find('.editable .profile-field');
            const editFields = section.find('.edit-field');
            editableFieldPlaceholders.toggleClass('hidden');
            editFields.toggleClass('hidden');
        },

        resetFieldEdits(e) {
            const editField = $(e.currentTarget).siblings('.edit-field');
            const fieldName = editField.attr('name');

            editField.val(this.currentUserData[fieldName]);
        },

        resetSectionEdits(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFields = section.find('.editable input, .editable select');

            editableFields.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');

                $(field).val(this.currentUserData[fieldName]);
            });
        },

        deleteEmail(e) {
            e.preventDefault();

            this.clearErrorFields();

            // Set the input and the placeholder to be empty strings.
            $('#email').val('');
            $('.email-field').find('.profile-field').val('');

            // then do our own save email call instead of using saveCurrentUserData
            this.saveEmail('');
        },

        clickSaveEmail(e) {
            e.preventDefault();

            const emailAddress = $('#email');
            this.saveEmail(emailAddress.val());
        },

        saveEmail(emailAddress) {
            const saveRequest = new VjsUtility.Request();
            saveRequest
                .post('/my-profile/save', { email: emailAddress })
                .done(() => {
                    const emailField = $('#email');
                    const validateEmailBtn = $('#validate-email-btn');
                    const validatedBtn = $('#validated-btn');
                    const deleteBtn = $('#delete-email-btn');
                    const addEmailBtn = $('#add-email-btn');
                    const editEmailBtn = $('#edit-email-btn');
                    const emailPlaceholder = $('.email-field .profile-field');
                    const saveBtn = $('#save-email-btn');
                    const cancelBtn = $('#cancel-email-edit-btn');

                    let notificationText = '';
                    saveBtn.addClass('hidden');
                    cancelBtn.addClass('hidden');
                    emailField.addClass('hidden');
                    emailPlaceholder.removeClass('hidden');

                    if (emailAddress !== '') {
                        notificationText = 'Email Saved!';

                        const currentValidatedEmail = validatedBtn.data('validated-email');
                        const validated = currentValidatedEmail === emailAddress;
                        deleteBtn.removeClass('hidden');
                        editEmailBtn.removeClass('hidden');
                        addEmailBtn.addClass('hidden');

                        if (validated) {
                            validateEmailBtn.addClass('hidden');
                            validatedBtn.removeClass('hidden');
                            emailPlaceholder.text(emailAddress);
                        } else {
                            validateEmailBtn.removeClass('hidden');
                            validatedBtn.addClass('hidden');
                            emailPlaceholder.text(`${emailAddress} (Not Validated)`);

                            this.sendValidationEmail();
                            notificationText += ' Sending Validation Email';
                        }
                    } else {
                        notificationText = 'Email Removed From Profile!';

                        validatedBtn.addClass('hidden');
                        validateEmailBtn.addClass('hidden');
                        deleteBtn.addClass('hidden');
                        editEmailBtn.addClass('hidden');
                        emailPlaceholder.text(emailAddress);

                        addEmailBtn.removeClass('hidden');
                    }

                    VjsUtility.Notification.success(notificationText);
                })
                .fail((fail) => {
                    const failData = fail.responseJSON;
                    VjsUtility.Notification.error(failData.message);

                    _.forOwn(failData.data, (value, key) => {
                        const errorField = $(`[name="${key}"]`);
                        const fieldContainer = $(errorField).closest('.info-field');
                        const errorTemplate = `<span class="field-error">
                                ${value}
                            </span>`;

                        $(errorTemplate).insertAfter(fieldContainer);
                    });
                });
        },

        saveCurrentUserData(e) {
            const section = $(e.currentTarget).closest('.profile-details');
            const editableFields = section.find('.editable input, .editable select, .editable-field input, .editable-field select, #email');
            const profileData = {};
            const saveData = {};
            let isSectionEdit = true;

            editableFields.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');
                const fieldValue = field.val();

                if (field.closest('.info-field').hasClass('editable-field')) {
                    isSectionEdit = false;
                }

                profileData[fieldName] = fieldValue;
            });

            _.forOwn(profileData, (value, key) => {
                if (value !== this.currentUserData[key]) {
                    saveData[key] = value;
                }
            });

            if (Object.keys(saveData).length > 0 && (saveData.password || saveData.password_confirm)) {
                // check if both password and password confirm are present and equal, otherwise don't bother sending it.
                if (saveData.password !== saveData.password_confirm) {
                    const errorField = $('[name="password"]');
                    const fieldContainer = $(errorField).closest('.info-field');
                    const errorTemplate = `<span class="field-error">
                                Passwords must match.
                            </span>`;

                    $(errorTemplate).insertBefore(fieldContainer);

                    return;
                }
            }

            if (Object.keys(saveData).length > 0) {
                const saveRequest = new VjsUtility.Request();
                saveRequest
                    .post('/my-profile/save', saveData)
                    .done(() => {
                        const notificationText = 'Profile Saved!';
                        this.toggleEditButtons(e);

                        if (isSectionEdit) {
                            this.toggleEditSection(e);
                        } else {
                            this.toggleEditField(e);
                        }

                        _.forOwn(saveData, (value, key) => {
                            $(`[data-placeholder="${key}"`).text(value);
                        });

                        VjsUtility.Notification.success(notificationText);
                    })
                    .fail((fail) => {
                        const failData = fail.responseJSON;
                        VjsUtility.Notification.error(failData.message);

                        _.forOwn(failData.data, (value, key) => {
                            const errorField = $(`[name="${key}"]`);
                            const fieldContainer = $(errorField).closest('.info-field');
                            const errorTemplate = `<span class="field-error">
                                ${value}
                            </span>`;

                            $(errorTemplate).insertBefore(fieldContainer);
                        });

                        if (saveData.password) {
                            $('#password, #confirm-password').val('');
                        }
                    });
            } else {
                this.toggleEditButtons(e);
                // this should toggle the section OR just the fields.
                if (isSectionEdit) {
                    this.toggleEditSection(e);
                } else {
                    this.toggleEditField(e);
                }
            }
        },

        getCurrentUserData(e) {
            const section = $(e.currentTarget).closest('form');
            const currentValues = section.find('.editable input, .editable select, .editable-field input, .editable-field select, #email');

            currentValues.each((index, element) => {
                const field = $(element);
                const fieldName = field.attr('name');
                const fieldValue = field.val();

                this.currentUserData[fieldName] = fieldValue;
            });
        },

        clickSendValidationEmail(e) {
            e.preventDefault();

            this.sendValidationEmail();
        },

        sendValidationEmail() {
            const email = $('#email').val();

            if (Jr.Utils.validateEmail(email)) {
                const validationButton = $('#validate-email-btn');
                const license = validationButton.data('license');
                const validationUrl = validationButton.data('validation-url');

                const sendValidation = new VjsUtility.Request();
                sendValidation
                    .post(validationUrl, { email, license })
                    .done(() => {
                        const validateEmailBtn = $('.validate-email-btn');
                        validateEmailBtn.removeClass('btn-red').addClass('btn-blue');
                        validateEmailBtn
                            .text('Email sent!')
                            .off()
                            .on('click', (event) => {
                                event.preventDefault();
                            });

                        VjsUtility.Notification.success('Email Validation Sent');
                    })
                    .fail(() => {
                        VjsUtility.Notification.error('Email Validation Failed To Send');
                    });
            }
        },
    });

    return postlogin;
}(Postlogin || {}));
